import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import restaurantReducer from "./restaurants";
import cartReducer from "./cart";
import logger from "redux-logger"
import sessionReducer from "./session";
import stripeReducer from "./stripe";
import orderReducer from "./order";

const rootReducer = combineReducers({
  // add reducer functions here
  restaurant: restaurantReducer,
  cart: cartReducer,
  session: sessionReducer,
  stripe: stripeReducer,
  order: orderReducer,
});

let enhancer;

if (process.env.NODE_ENV === "production") {
  enhancer = applyMiddleware(thunk);
} else {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  enhancer = composeEnhancers(applyMiddleware(thunk, logger));
}

const configureStore = (preloadedState) => {
  return createStore(rootReducer, preloadedState, enhancer);
};

export default configureStore;
